<div class="container-fluid">
  <div class="row justify-content-center pt-5 pb-5 cards-row" style="margin-top: 1vw;">
    <div *ngFor="let card of visibleCards" style="max-width: 200px;" class="home-card-column col-xl-2 col-lg-3 col-md-4 col-sm-6 col-6 mb-4 d-flex justify-content-center">
      <div class="card p-3 w-100 h-100 d-flex flex-column align-items-center">
        <div style="height: 30px;" class="card-title">{{ card.title }}</div>
        <div class="divider"></div>
        <img [src]="card.icon" class="card-icon mx-auto">
        <button *ngIf="card.route" [routerLink]="card.route" class="access-button mt-auto">Accede</button>
        <button *ngIf="!card.route" class="access-button mt-auto" disabled>Accede</button>
      </div>
    </div>
  </div>
</div>